import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import makeStyles from '@mui/styles/makeStyles';

import SharedAsset from '#client/components/SharedAsset';

import accountingPlans from './accountingPlans.json';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      padding: 24,
      width: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: '800px'
      }
    }
  },
  title: {
    marginBottom: 8
  },
  content: {
    marginBottom: 16
  },
  featureValue: {
    fontWeight: 'bold'
  },
  planCell: {
    padding: 8
  },
  toolbar: theme.mixins.toolbar
}));

const messages = {
  accountingType: {
    accounting: 'Accounting',
    accounting_grow_and_scale: 'Grow and Scale',
    accounting_quick_start: 'Quick Start',
    accounting_up_and_running: 'Up and Running'
  }
};

const interpetFeatureValue = (val) => {
  if (val === true) {
    return 'Yes';
  }
  return val;
};
const showFeature = (val) => (
  val !== false
);

const AccountingPlanDetailsModal = ({ open, onClose, accountingType }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { features = [] } = accountingPlans[accountingType] || {};

  return (
    <>
      {!fullScreen && <div className={classes.toolbar} />}
      <Dialog
        open={open}
        onClose={onClose}
        className={classes.root}
        maxWidth={false}
        fullScreen={fullScreen}
      >
        {fullScreen && <div className={classes.toolbar} />}
        <DialogTitle className={classes.title}>
          <Grid container direction="row">
            <Grid item xs>
              <Typography variant="h3">
                {`${messages.accountingType[accountingType]} Plan Features`}
              </Typography>
            </Grid>
            <Grid item align="right">
              <IconButton onClick={onClose} size="large">
                <SharedAsset src="/icon/micro/close-x.svg" width={16} alt="close" />
              </IconButton>
            </Grid>
          </Grid>
          <Divider />
        </DialogTitle>
        <DialogContent className={classes.content}>
          {features.map(({ name, value }, i) => showFeature(value) && (
          <Grid key={name} container style={{ backgroundColor: (i % 2 ? '#F1F4F5' : 'inherit') }}>
            <Grid item xs className={classes.planCell}>
              <Typography variant="body2" color="textSecondary">{name}</Typography>
            </Grid>
            <Grid item xs className={classes.planCell}>
              <Typography variant="body2" className={classes.featureValue}>
                {interpetFeatureValue(value)}
              </Typography>
            </Grid>
          </Grid>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};

AccountingPlanDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accountingType: PropTypes.string
};

AccountingPlanDetailsModal.defaultProps = {
  accountingType: null
};

export default AccountingPlanDetailsModal;
